const step_up = {
    verify_your_identity: 'Bestätige deine Identität',
    choose_method_description: 'Um fortzufahren, bestätige mit einer der folgenden Methoden, dass du es bist.',
    password: 'Passwort',
    password_description: 'Gib das Passwort deines Kontos ein',
    enter_password_description: 'Gib zum Fortfahren das Passwort deines Kontos ein.',
    enter_verification_code_description: 'Gib den Verifizierungscode ein, der an {{identifier}} gesendet wurde.',
    subject_proof_description: 'Um fortzufahren, bestätige über ein mit deinem Konto verknüpftes Konto, dass du es bist. Anschließend kannst du eine Verifizierungsmethode einrichten.',
    subject_mismatch: 'Konto stimmt nicht überein',
    subject_mismatch_description: 'Das verwendete Konto ist nicht mit deinem Konto verknüpft. Verwende ein verknüpftes Konto und wechsle bei Bedarf beim Anbieter das Konto.',
    no_method_available: 'Keine Verifizierungsmethode verfügbar',
    no_method_available_description: 'Dein Konto hat keine Methode, mit der diese Verifizierung abgeschlossen werden kann. Bitte wende dich an deinen Administrator, um Hilfe zu erhalten.',
};
export default Object.freeze(step_up);
